import {ICommonGallery} from "../interfaces";

interface ICommonGalleryProps {
    commonGalleryProps: ICommonGallery,
}
/**
 * the entry point
 */
const ProductTeaserButton = (props: ICommonGalleryProps) => {

    const commonGalleryProps = props.commonGalleryProps;
    let textProductPlugins = "";
    switch(commonGalleryProps.urlPathName){
        case 'bundles':
        case 'subscriptions':
        case 'courses':{
            textProductPlugins = commonGalleryProps?.totalProducts +  ' Plugins Included';
            break;
        }
        case 'hardware':
        case 'plugins':{
            textProductPlugins = commonGalleryProps?.totalProducts +  ' Products Included';
            break;
        }

    }

    return (

            <>
                {
                    <div className="flex justify-center items-center mb-8 relative">
                        <div className="list-menu-grad-top" />
                        <a href="#tab-includes" className="w-btn w-64 lg:w-96">See All {textProductPlugins}</a>
                    </div>
                }
            </>
    )
};

export default ProductTeaserButton;